import { render, staticRenderFns } from "./mobile_consult_manage.vue?vue&type=template&id=5586bc74&scoped=true&"
import script from "./mobile_consult_manage.vue?vue&type=script&lang=js&"
export * from "./mobile_consult_manage.vue?vue&type=script&lang=js&"
import style0 from "./mobile_consult_manage.vue?vue&type=style&index=0&id=5586bc74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586bc74",
  null
  
)

export default component.exports